// @preval
// Copyright (c) 2015-present, Salesforce, Inc. All rights reserved
// Licensed under BSD 3-Clause - see LICENSE.txt or git.io/sfdc-license

const fs = require('fs');
const path = require('path');
const config = require('../data/global-styling-hooks.config.json');
const findNodeModules = require("../helpers/findNodeModules");
const nodeModulesDir = findNodeModules(__dirname);
const SLDS_V_1 = "slds-v1"; //default
const SLDS_V_2 = "slds-v2";
let dsVer = SLDS_V_1;

const sldsModule =
  dsVer === SLDS_V_2
    ? "@salesforce-ux/sds-styling-hooks"
    : "@salesforce-ux/design-system";

const globalStylingHooksPath = path.resolve.bind(
  path,
  dsVer === SLDS_V_2
    ? `${nodeModulesDir}/${sldsModule}/dist`
    : `${nodeModulesDir}/${sldsModule}/design-tokens/dist`
);

const getJsonFilePath = fileName => globalStylingHooksPath(fileName);

const readJsonFile = file => {
  try {
    return JSON.parse(fs.readFileSync(file));
  } catch (error) {
    // Return an empty object instead of breaking
    if (error.code === "ENOENT") {
      console.warn(`/// WARN: Couldn't find ${file}`);
      return {};
    } else {
      throw error;
    }
  }
}

const getPropsFromJson = json => json.props || {};

// const createJsonForCategory = _ => ({ stylingHooks: {} });

/**
 * Return category name if styling hook type and group
 * matches the category type and either of category group
 */
const hasMatchingCategory = ({category, group, type}, categories) => {
  const { groups: categoryGroups, type: categoryType } = categories[category];
  return categoryGroups.includes(group) && type === categoryType;
};

const findMatchingCategory = ({group, type}, categories) =>
  Object.keys(categories).find(category => hasMatchingCategory({category, group, type}, categories));

const findCategoryForHook = ({group, type}, categories) => {
  const foundCategory = findMatchingCategory({group, type}, categories);
  return foundCategory ? foundCategory : 'Others'; // fallback category
};

// const populateCategoryDetails = (results, categories) => {
//   Object.keys(results)
//     .forEach(category => {
//       const { description, label } = categories[category];
//       results[category].description = description;
//       results[category].label = label;
//     });
//   return results;
// };

const prepareHooksData = (props, categories) => {
  const allHooks = [];
  Object.keys(props)
    .forEach(key => {
      const { comment, name, value, originalValue, scope, group, type } = props[key];
      allHooks.push({
        name: `--slds-g-${name}`,
        groupCategory: findCategoryForHook({group, type}, categories),
        value: value && value.startsWith('#') ? value.toUpperCase() : value,
        originalValue: originalValue && originalValue.startsWith('rgb') ? '' : originalValue.replace(/{|}|!/g, ''),
        scope: scope,
        comment: comment,
      })
    });

    return allHooks;
};

const generate = () => {
  const allProps = config.files
    .map(getJsonFilePath)
    .map(readJsonFile)
    .map(getPropsFromJson)
    .reduce((result, curr) => {
      return { ...result, ...curr };
    }, {});

  return prepareHooksData(allProps, config.categories);
};

module.exports = generate();
